//================================================================
//  Component: Cancel Request Modal
//================================================================

//  Purpose: This modal will allow users to cancel a business request task

//  Properties:
//    - cancelRequestModal = {useState, used to storethe current request and determine if the modal is visible}
//    - setCancelRequestModal = {useState, used to toggle the visibility of the cancel request modal}
//    - task = {object, used to store the current task}

//  Example:
//    <CancelRequestModal
//      cancelRequestModal={cancelRequestModal}
//      setCancelRequestModal={setCancelRequestModal}
//      task={task}
//    ></CancelRequestModal>

//================================================================

//Libraries
import React, { useState, useContext } from 'react';

//Contexts
import { GetUser } from '../../../../Library/GlobalContexts';

//Components

//Functions
import WriteDocument from '../../../../Library/WriteDocument';

//Images
import Error from '../../../../Components/Images/Icon_ErrorFatal_Red.svg';
import ErrorIcon from '../../../../Components/Images/Icon_Error_Red.svg';

export default function CancelRequestModal({
  cancelRequestModal,
  setCancelRequestModal,
  task
}) {

  //------------------------------------------------------
  //  useContexts
  //------------------------------------------------------

  const getUser = useContext(GetUser);

  //------------------------------------------------------
  //  useStates
  //------------------------------------------------------

  // Used to set modal status > 'onload', 'error'
  const [modalStatus, setModalStatus] = useState('onload');

  // Used to store comment of the cancel request
  const [cancelRequestComment, setCancelRequestComment] = useState('');

  //------------------------------------------------------
  //  Functions
  //------------------------------------------------------

  // Used to cancel request
  function cancelRequest() {

    const updatedTask = {
      ...task,
      'status': 'Cancelled',
      'cancellationreason': cancelRequestComment,
      'lastmodifiedby': {
        'email': getUser?.emailaddress,
        'givenname': getUser?.givenname,
        'surname': getUser?.surname
      },
      'lastmodifieddate': new Date(),
      'activityfeed': [
        ...task?.activityfeed,
        {
          'activitydate': new Date(),
          'actionedby': {
            'email': getUser?.emailaddress,
            'givenname': getUser?.givenname,
            'surname': getUser?.surname
          },
          'action': 'cancelled',
          'comments': cancelRequestComment
        }
      ]
    }

    WriteDocument('requests', task.requestid, updatedTask,true)
    .then(() => {

      setCancelRequestModal(undefined);

    })
    .catch((error) => {

      console.log('error', error);
      setModalStatus('error');

    });

  }


  //------------------------------------------------------
  //  HTML
  //------------------------------------------------------

  if (cancelRequestModal === undefined || cancelRequestModal === false) return null;

  // ---------------------------------------------------
  //  Onload
  // ---------------------------------------------------

  if (modalStatus === 'onload') {

    return (
      <div className='Modal-Background'>

        {/* Modal Container */}
        <dialog className='Warning-Modal-Container w-[650px] p-0'>

          {/* Header */}
          <div className='flex flex-row items-center px-4 py-[20px] border-b-[1px] border-b-[#D8D8D8]'>
            <h4 className='m-0'>Cancel Request</h4>
          </div>

          {/* Body */}
          <div className='flex flex-col gap-[20px] px-4 py-[5px]'>

            {/* Change Status */}
            <div className='flex flex-col gap-3'>
              <label className='font-medium'> Change status:</label>
              <input
                className='Input-Field-Text !w-full'
                type='text'
                defaultValue='Cancel'
                disabled
              ></input>
            </div>

            {/* Comment */}
            <div className='flex flex-col gap-3'>
              <label className='font-semibold'> Comment: <span className='text-[#C4314B]'>*</span> </label>
              <textarea
                className='Input-Field-TextArea'
                placeholder='Enter a reason for cancelling this request'
                value={cancelRequestComment}
                onChange={(e) => setCancelRequestComment(e.target.value)}
              ></textarea>
            </div>
            
          </div>
          
          {/* Warning Box */}
          <div className='flex flex-row gap-3 px-3 py-3 mx-4 my-2 border-[1px] border-red-600 rounded-lg bg-[#FCF4F6]'>
            <img src={ErrorIcon} alt='error-icon' width='25px' height='25px'></img>
            <div className='text-sm leading-6'>
              Cancelling this request will close this task. Notification will be sent to the Commercial Manager. 
            </div>
          </div>

          {/* Buttons */}
          <div className='flex flex-row items-center gap-2 py-3 px-4 border-t-[1px] border-t-[#D8D8D8]'>

            {/* Cancel Request */}
            <button 
              disabled={cancelRequestComment.trim() === ''} 
              className='Warning-Button' 
              onClick={() => cancelRequest()}
            >
              Cancel Request
            </button>
            
            {/* Cancel */}
            <button
              className='Secondary-Button'
              style={{ color: '#424242', border: '1px solid #424242' }}
              onClick={() => setCancelRequestModal(undefined)}
            >
              Cancel
            </button>
            
          </div>

        </dialog>
      </div>
    )
  }

  // ---------------------------------------------------
  //  Error
  // ---------------------------------------------------


  else if (modalStatus === 'error') {
    return (
      <div className='Modal-Background'>

        {/* Modal Container */}
        <dialog className='Warning-Modal-Container justify-center items-center'>

          <img className='my-1 w-[50px]' src={Error} alt='Error'></img>
          <h4 className='mb-0'>Oops! Something went wrong.</h4>

          <p className='text-center leading-[1.7]'>
            An error occurred while we processed your request.
          </p>

          <button
            className='Warning-Button'
            onClick={() => {
              setModalStatus('onload');
              setCancelRequestModal(undefined);
            }}
          >
            Close
          </button>

        </dialog>

      </div>
    )
  }

  //------------------------------------------------------
}
